import * as React from 'react'
import { ArrowSvgProps } from './CurvedArrowSvg'
import { Box } from '@mui/material'
import { useAnimationStyles } from 'src/Libs/live-view'
import EnergyFlowIndicatorSvg from './EnergyFlowIndicatorSvg'

const StraightArrowShortSvg: React.FC<ArrowSvgProps> = ({ direction, transform, doRotateBy180Deg = false, sx }) => {
  const { classes, cx } = useAnimationStyles({ direction })

  return (
    <Box sx={{ position: 'relative', transform, ...sx }}>
      <svg width={15} height={46} viewBox="0 0 15 44" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="livevalue_arrow_straight">
          <g id="line">
            <path id="Vector 8" d="M7.50391 39.9999L7.50391 21.6491L7.5039 2.99988" stroke="#A4AAAE" strokeWidth={2} strokeLinecap="round" />
          </g>
          {direction === 'out' && (
            <g id="arrow_out">
              <path
                d="M0.293322 36.7084L0.224959 36.6331C-0.0955772 36.2403 -0.0728614 35.6603 0.293322 35.2941C0.659506 34.928 1.23949 34.9052 1.63227 35.2258L1.70754 35.2941L8.20615 41.7928C8.59668 42.1833 8.59668 42.8164 8.20615 43.207C7.81563 43.5975 7.18246 43.5975 6.79194 43.207L0.293322 36.7084Z"
                fill="#A4AAAE"
              />
              <path
                d="M13.294 35.2929L13.37 35.2239C13.7628 34.9037 14.3422 34.9269 14.7083 35.2929C15.0988 35.6834 15.0988 36.3166 14.7083 36.7071L8.20825 43.2071C7.81773 43.5976 7.18457 43.5976 6.79404 43.2071C6.40352 42.8166 6.40352 42.1834 6.79404 41.7929L13.294 35.2929Z"
                fill="#A4AAAE"
              />
            </g>
          )}
          {direction === 'in' && (
            <g id="arrow_in">
              <path
                d="M14.7077 6.79165L14.776 6.86692C15.0966 7.2597 15.0738 7.83968 14.7077 8.20586C14.3415 8.57205 13.7615 8.59476 13.3687 8.27423L13.2934 8.20586L6.79483 1.70725C6.4043 1.31672 6.4043 0.683558 6.79483 0.293034C7.18535 -0.0974904 7.81852 -0.0974904 8.20904 0.293034L14.7077 6.79165Z"
                fill="#A4AAAE"
              />
              <path
                d="M1.70694 8.20709L1.63098 8.27615C1.23821 8.59633 0.658781 8.57315 0.292727 8.20709C-0.0977978 7.81657 -0.0977976 7.1834 0.292727 6.79288L6.79272 0.292884C7.18325 -0.0976402 7.81641 -0.097641 8.20694 0.292883C8.59746 0.683408 8.59746 1.31657 8.20694 1.7071L1.70694 8.20709Z"
                fill="#A4AAAE"
              />
            </g>
          )}
          v
        </g>
      </svg>
      {!!direction && (
        <EnergyFlowIndicatorSvg
          className={cx(classes.directionIndicator, classes.straightArrowShortAnimation)}
          doRotateBy180Deg={doRotateBy180Deg}
          direction={direction}
        />
      )}
    </Box>
  )
}

export default StraightArrowShortSvg
